import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@tabler/icons-webfont/dist/tabler-icons.min.css?1692870487";
import "./assets/css/main.css";
import VueImg from "v-img";

import store from "./store";

Vue.prototype.$bus = new Vue();
Vue.use(VueImg);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;
new Vue({
  router,
  render: (h) => h(App),
  store,
}).$mount("#app");
